/**
 * ArkScrollbar - 纯 JS 自定义滚动条
 * 支持：边缘检测、虚拟滚动
 */
(function () {
    if (window.ArkScrollbar) return;

    var instances = new Map();

    window.ArkScrollbar = {
        /**
         * 初始化滚动条
         */
        init: function (container, options, dotNetRef) {
            if (!container) return null;

            var id = 'ark-' + Math.random().toString(36).substr(2, 9);
            container.setAttribute('data-ark-id', id);

            var viewport = container.querySelector('.ark-scrollbar-viewport');
            var content = container.querySelector('.ark-scrollbar-content');
            var trackY = container.querySelector('.ark-scrollbar-track-y');
            var thumbY = container.querySelector('.ark-scrollbar-thumb-y');
            var trackX = container.querySelector('.ark-scrollbar-track-x');
            var thumbX = container.querySelector('.ark-scrollbar-thumb-x');

            if (!viewport || !content) return null;

            var state = {
                id: id,
                container: container,
                viewport: viewport,
                content: content,
                trackY: trackY,
                thumbY: thumbY,
                trackX: trackX,
                thumbX: thumbX,
                options: options,
                dotNetRef: dotNetRef,
                isDraggingY: false,
                isDraggingX: false,
                dragStartY: 0,
                dragStartX: 0,
                scrollStartY: 0,
                scrollStartX: 0,
                scrollTimer: null,
                resizeObserver: null,
                // destroy 时统一移除：{ target, type, fn, opts }
                handlers: [],
                // 边缘状态
                wasAtTop: true,
                wasAtBottom: false,
                wasAtLeft: true,
                wasAtRight: false,
                // 边缘检测阈值
                edgeThreshold: options.edgeThreshold || 1,
                // 虚拟滚动状态
                virtualEnabled: options.virtualize || false,
                virtualItemHeight: options.itemHeight || 50,
                virtualOverscan: options.overscan || 3,
                virtualTotalCount: 0,
                virtualStartIndex: 0,
                virtualEndIndex: 0
            };

            instances.set(id, state);
            this._bindEvents(state);
            this._update(state);

            // 监听内容大小变化
            if (window.ResizeObserver) {
                state.resizeObserver = new ResizeObserver(function () {
                    window.ArkScrollbar._update(state);
                });
                state.resizeObserver.observe(content);
                state.resizeObserver.observe(viewport);
            }

            return id;
        },

        /**
         * 绑定事件
         */
        _bindEvents: function (state) {
            var self = this;
            var viewport = state.viewport;
            var options = state.options;

            // 统一登记：destroy 时一次性 removeEventListener
            var bind = function (target, type, fn, opts) {
                target.addEventListener(type, fn, opts);
                state.handlers.push({ target: target, type: type, fn: fn, opts: opts });
            };

            // 滚动事件
            bind(viewport, 'scroll', function () { self._onScroll(state); }, { passive: true });

            // 垂直滑块
            if (state.thumbY) {
                bind(state.thumbY, 'mousedown', function (e) { self._onThumbDown(e, state, 'y'); });
                bind(state.thumbY, 'touchstart', function (e) { self._onThumbTouch(e, state, 'y'); }, { passive: false });
            }

            // 水平滑块
            if (state.thumbX) {
                bind(state.thumbX, 'mousedown', function (e) { self._onThumbDown(e, state, 'x'); });
                bind(state.thumbX, 'touchstart', function (e) { self._onThumbTouch(e, state, 'x'); }, { passive: false });
            }

            // 轨道点击
            if (state.trackY && options.clickScroll) {
                bind(state.trackY, 'click', function (e) { self._onTrackClick(e, state, 'y'); });
            }
            if (state.trackX && options.clickScroll) {
                bind(state.trackX, 'click', function (e) { self._onTrackClick(e, state, 'x'); });
            }

            // 全局事件
            bind(document, 'mousemove', function (e) { self._onMouseMove(e, state); });
            bind(document, 'mouseup', function (e) { self._onMouseUp(e, state); });
            bind(document, 'touchmove', function (e) { self._onTouchMove(e, state); }, { passive: false });
            bind(document, 'touchend', function (e) { self._onMouseUp(e, state); });
        },

        /**
         * 滚动事件
         */
        _onScroll: function (state) {
            this._update(state);
            this._checkEdge(state);

            // 虚拟滚动更新
            if (state.virtualEnabled) {
                this._updateVirtualScroll(state);
            }

            // 自动隐藏
            if (state.options.autoHide) {
                state.container.classList.add('ark-scrollbar-scrolling');
                clearTimeout(state.scrollTimer);
                state.scrollTimer = setTimeout(function () {
                    state.container.classList.remove('ark-scrollbar-scrolling');
                }, state.options.autoHideDelay || 1000);
            }

            // 回调 .NET
            if (state.dotNetRef) {
                var vp = state.viewport;
                state.dotNetRef.invokeMethodAsync('OnScrollCallback',
                    vp.scrollTop,
                    vp.scrollLeft,
                    vp.scrollHeight,
                    vp.scrollWidth,
                    vp.clientHeight,
                    vp.clientWidth
                ).catch(function () { /* 组件可能已销毁 */ });
            }
        },

        /**
         * 边缘检测
         */
        _checkEdge: function (state) {
            var vp = state.viewport;
            var threshold = state.edgeThreshold;
            var dotNetRef = state.dotNetRef;

            var isAtTop = vp.scrollTop <= threshold;
            var isAtBottom = vp.scrollTop >= vp.scrollHeight - vp.clientHeight - threshold;
            var isAtLeft = vp.scrollLeft <= threshold;
            var isAtRight = vp.scrollLeft >= vp.scrollWidth - vp.clientWidth - threshold;

            // 触发边缘事件
            if (dotNetRef) {
                var swallow = function () { /* 组件可能已销毁 */ };
                if (isAtTop && !state.wasAtTop) {
                    dotNetRef.invokeMethodAsync('OnReachTopCallback').catch(swallow);
                }
                if (isAtBottom && !state.wasAtBottom) {
                    dotNetRef.invokeMethodAsync('OnReachBottomCallback').catch(swallow);
                }
                if (isAtLeft && !state.wasAtLeft) {
                    dotNetRef.invokeMethodAsync('OnReachLeftCallback').catch(swallow);
                }
                if (isAtRight && !state.wasAtRight) {
                    dotNetRef.invokeMethodAsync('OnReachRightCallback').catch(swallow);
                }
            }

            // 更新状态
            state.wasAtTop = isAtTop;
            state.wasAtBottom = isAtBottom;
            state.wasAtLeft = isAtLeft;
            state.wasAtRight = isAtRight;
        },

        /**
         * 更新滚动条
         */
        _update: function (state) {
            var vp = state.viewport;
            var scrollH = vp.scrollHeight;
            var scrollW = vp.scrollWidth;
            var clientH = vp.clientHeight;
            var clientW = vp.clientWidth;

            // 垂直
            if (state.thumbY && state.trackY) {
                var hasY = scrollH > clientH;
                state.trackY.style.display = hasY ? '' : 'none';

                if (hasY) {
                    var trackH = state.trackY.clientHeight;
                    var thumbH = Math.max(30, (clientH / scrollH) * trackH);
                    var maxTop = trackH - thumbH;
                    var ratioY = vp.scrollTop / (scrollH - clientH);

                    state.thumbY.style.height = thumbH + 'px';
                    state.thumbY.style.transform = 'translateY(' + (ratioY * maxTop) + 'px)';
                }
            }

            // 水平
            if (state.thumbX && state.trackX) {
                var hasX = scrollW > clientW;
                state.trackX.style.display = hasX ? '' : 'none';

                if (hasX) {
                    var trackW = state.trackX.clientWidth;
                    var thumbW = Math.max(30, (clientW / scrollW) * trackW);
                    var maxLeft = trackW - thumbW;
                    var ratioX = vp.scrollLeft / (scrollW - clientW);

                    state.thumbX.style.width = thumbW + 'px';
                    state.thumbX.style.transform = 'translateX(' + (ratioX * maxLeft) + 'px)';
                }
            }

            // 更新类
            state.container.classList.toggle('ark-has-overflow-y', scrollH > clientH);
            state.container.classList.toggle('ark-has-overflow-x', scrollW > clientW);
        },

        /**
         * 虚拟滚动：设置总数量
         */
        setVirtualItemCount: function (id, count) {
            var state = instances.get(id);
            if (!state) return;

            state.virtualTotalCount = count;
            this._updateVirtualScroll(state);
        },

        /**
         * 虚拟滚动：设置项高度
         */
        setVirtualItemHeight: function (id, height) {
            var state = instances.get(id);
            if (!state) return;

            state.virtualItemHeight = height;
            this._updateVirtualScroll(state);
        },

        /**
         * 虚拟滚动：更新可见范围
         */
        _updateVirtualScroll: function (state) {
            if (!state.virtualEnabled || state.virtualTotalCount === 0) return;

            var vp = state.viewport;
            var itemHeight = state.virtualItemHeight;
            var overscan = state.virtualOverscan;
            var totalCount = state.virtualTotalCount;
            var scrollTop = vp.scrollTop;
            var clientHeight = vp.clientHeight;

            // 计算可见范围
            var startIndex = Math.floor(scrollTop / itemHeight);
            var endIndex = Math.min(
                totalCount - 1,
                Math.floor((scrollTop + clientHeight) / itemHeight)
            );

            // 添加 overscan
            startIndex = Math.max(0, startIndex - overscan);
            endIndex = Math.min(totalCount - 1, endIndex + overscan);

            // 如果范围变化，通知 .NET
            if (startIndex !== state.virtualStartIndex || endIndex !== state.virtualEndIndex) {
                state.virtualStartIndex = startIndex;
                state.virtualEndIndex = endIndex;

                if (state.dotNetRef) {
                    state.dotNetRef.invokeMethodAsync('OnVirtualRangeChanged', startIndex, endIndex)
                        .catch(function () { /* 组件可能已销毁 */ });
                }
            }
        },

        /**
         * 获取虚拟滚动信息
         */
        getVirtualScrollInfo: function (id) {
            var state = instances.get(id);
            if (!state) return null;

            return {
                startIndex: state.virtualStartIndex,
                endIndex: state.virtualEndIndex,
                totalHeight: state.virtualTotalCount * state.virtualItemHeight,
                offsetY: state.virtualStartIndex * state.virtualItemHeight,
                itemHeight: state.virtualItemHeight,
                totalCount: state.virtualTotalCount
            };
        },

        // ============ 以下为原有方法 ============

        _onThumbDown: function (e, state, axis) {
            e.preventDefault();
            e.stopPropagation();

            if (axis === 'y') {
                state.isDraggingY = true;
                state.dragStartY = e.clientY;
                state.scrollStartY = state.viewport.scrollTop;
                state.thumbY.classList.add('ark-active');
            } else {
                state.isDraggingX = true;
                state.dragStartX = e.clientX;
                state.scrollStartX = state.viewport.scrollLeft;
                state.thumbX.classList.add('ark-active');
            }
            document.body.style.userSelect = 'none';
        },

        _onThumbTouch: function (e, state, axis) {
            if (e.touches.length !== 1) return;
            e.preventDefault();

            var touch = e.touches[0];
            if (axis === 'y') {
                state.isDraggingY = true;
                state.dragStartY = touch.clientY;
                state.scrollStartY = state.viewport.scrollTop;
                state.thumbY.classList.add('ark-active');
            } else {
                state.isDraggingX = true;
                state.dragStartX = touch.clientX;
                state.scrollStartX = state.viewport.scrollLeft;
                state.thumbX.classList.add('ark-active');
            }
        },

        _onMouseMove: function (e, state) {
            if (state.isDraggingY) {
                var delta = e.clientY - state.dragStartY;
                var trackH = state.trackY.clientHeight;
                var thumbH = state.thumbY.clientHeight;
                var scrollable = state.viewport.scrollHeight - state.viewport.clientHeight;
                var ratio = scrollable / (trackH - thumbH);
                state.viewport.scrollTop = state.scrollStartY + delta * ratio;
            }

            if (state.isDraggingX) {
                var deltaX = e.clientX - state.dragStartX;
                var trackW = state.trackX.clientWidth;
                var thumbW = state.thumbX.clientWidth;
                var scrollableX = state.viewport.scrollWidth - state.viewport.clientWidth;
                var ratioX = scrollableX / (trackW - thumbW);
                state.viewport.scrollLeft = state.scrollStartX + deltaX * ratioX;
            }
        },

        _onTouchMove: function (e, state) {
            if (!state.isDraggingY && !state.isDraggingX) return;
            if (e.touches.length !== 1) return;
            e.preventDefault();

            var touch = e.touches[0];
            if (state.isDraggingY) {
                var delta = touch.clientY - state.dragStartY;
                var trackH = state.trackY.clientHeight;
                var thumbH = state.thumbY.clientHeight;
                var scrollable = state.viewport.scrollHeight - state.viewport.clientHeight;
                state.viewport.scrollTop = state.scrollStartY + delta * (scrollable / (trackH - thumbH));
            }
            if (state.isDraggingX) {
                var deltaX = touch.clientX - state.dragStartX;
                var trackW = state.trackX.clientWidth;
                var thumbW = state.thumbX.clientWidth;
                var scrollableX = state.viewport.scrollWidth - state.viewport.clientWidth;
                state.viewport.scrollLeft = state.scrollStartX + deltaX * (scrollableX / (trackW - thumbW));
            }
        },

        _onMouseUp: function (e, state) {
            if (state.isDraggingY) {
                state.isDraggingY = false;
                if (state.thumbY) state.thumbY.classList.remove('ark-active');
            }
            if (state.isDraggingX) {
                state.isDraggingX = false;
                if (state.thumbX) state.thumbX.classList.remove('ark-active');
            }
            document.body.style.userSelect = '';
        },

        _onTrackClick: function (e, state, axis) {
            if (e.target.classList.contains('ark-scrollbar-thumb-y') ||
                e.target.classList.contains('ark-scrollbar-thumb-x')) {
                return;
            }

            var vp = state.viewport;
            var behavior = state.options.smooth ? 'smooth' : 'auto';

            if (axis === 'y') {
                var rect = state.trackY.getBoundingClientRect();
                var ratio = (e.clientY - rect.top) / rect.height;
                vp.scrollTo({ top: ratio * (vp.scrollHeight - vp.clientHeight), behavior: behavior });
            } else {
                var rectX = state.trackX.getBoundingClientRect();
                var ratioX = (e.clientX - rectX.left) / rectX.width;
                vp.scrollTo({ left: ratioX * (vp.scrollWidth - vp.clientWidth), behavior: behavior });
            }
        },

        /**
         * 滚动到位置
         */
        scrollTo: function (id, x, y, smooth) {
            var state = instances.get(id);
            if (!state) return;

            var opts = { behavior: smooth ? 'smooth' : 'auto' };
            if (x !== null && x !== undefined) opts.left = x;
            if (y !== null && y !== undefined) opts.top = y;
            state.viewport.scrollTo(opts);
        },

        /**
         * 滚动到元素
         */
        scrollToElement: function (id, selector, smooth) {
            var state = instances.get(id);
            if (!state) return;

            var el = state.content.querySelector(selector);
            if (el) {
                var rect = el.getBoundingClientRect();
                var vpRect = state.viewport.getBoundingClientRect();
                state.viewport.scrollTo({
                    top: state.viewport.scrollTop + rect.top - vpRect.top,
                    left: state.viewport.scrollLeft + rect.left - vpRect.left,
                    behavior: smooth ? 'smooth' : 'auto'
                });
            }
        },

        /**
         * 只在元素不完整可见时才滚动，且只滚到「刚好露全」的最近一边（上方露不全 → 顶对齐；下方 → 底对齐）。
         * 与 scrollToElement 的区别：后者恒把元素顶到视口顶部，元素本来就可见时也会跳一下。
         * 用途：购物车合并加菜后把被合并的那一行带进视口（动效规范 §2⑥），瞬时滚动不做 smooth ——
         * Android WebView 上平滑滚动与高亮淡出同时跑，是两路动画抢一帧。
         */
        scrollIntoViewIfNeeded: function (id, selector) {
            var state = instances.get(id);
            if (!state) return;

            var el = state.content.querySelector(selector);
            if (!el) return;

            var rect = el.getBoundingClientRect();
            var vpRect = state.viewport.getBoundingClientRect();
            var delta = 0;
            if (rect.top < vpRect.top) delta = rect.top - vpRect.top;
            else if (rect.bottom > vpRect.bottom) delta = Math.min(rect.bottom - vpRect.bottom, rect.top - vpRect.top);
            if (delta !== 0) state.viewport.scrollTop += delta;
        },

        /**
         * 滚动到虚拟列表项
         */
        scrollToIndex: function (id, index, smooth) {
            var state = instances.get(id);
            if (!state || !state.virtualEnabled) return;

            var y = index * state.virtualItemHeight;
            this.scrollTo(id, null, y, smooth);
        },

        /**
         * 更新
         */
        update: function (id) {
            var state = instances.get(id);
            if (state) this._update(state);
        },

        /**
         * 获取滚动信息
         */
        getScrollInfo: function (id) {
            var state = instances.get(id);
            if (!state) return null;

            var vp = state.viewport;
            return {
                scrollTop: vp.scrollTop,
                scrollLeft: vp.scrollLeft,
                scrollHeight: vp.scrollHeight,
                scrollWidth: vp.scrollWidth,
                clientHeight: vp.clientHeight,
                clientWidth: vp.clientWidth,
                hasOverflowY: vp.scrollHeight > vp.clientHeight,
                hasOverflowX: vp.scrollWidth > vp.clientWidth
            };
        },

        /**
         * 销毁
         */
        destroy: function (id) {
            var state = instances.get(id);
            if (!state) return;

            clearTimeout(state.scrollTimer);

            if (state.resizeObserver) {
                state.resizeObserver.disconnect();
                state.resizeObserver = null;
            }

            // 切断所有 listener — 既防泄漏，也阻断 dispose 后的回调链
            if (state.handlers) {
                for (var i = 0; i < state.handlers.length; i++) {
                    var h = state.handlers[i];
                    h.target.removeEventListener(h.type, h.fn, h.opts);
                }
                state.handlers.length = 0;
            }

            // 兜底：即使有 listener 残留也无法跨过 .NET — 调用前会 if (state.dotNetRef) 短路
            state.dotNetRef = null;

            instances.delete(id);
        }
    };
})();